import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import PricingSection from '../components/PricingSection';
import Seo from '../seo/Seo';
import { buildBreadcrumbSchema } from '../seo/structuredData';
import { trackEvent } from '../utils/analytics';

function CreditsPage() {
  const breadcrumb = buildBreadcrumbSchema([
    { name: 'Home', path: '/' },
    { name: 'Credits', path: '/credits' },
  ]);
  const [searchParams] = useSearchParams();
  const paymentSuccess = searchParams.get('payment') === 'success';

  useEffect(() => {
    trackEvent('credits_page_visited');
  }, []);

  return (
    <div className="page landing-bg">
      <Seo
        title="Buy Image Credits | MyRoomsAI"
        description="Choose a MyRoomsAI credit pack and generate more interior design images anytime."
        canonicalPath="/credits"
        structuredData={breadcrumb}
      />
      <Navbar />
      <main className="container credits-page">

        {paymentSuccess && (
          <div
            className="credits-success-banner"
            role="status"
            aria-live="polite"
          >
            Payment successful. Your credits will appear shortly.
          </div>
        )}

        <PricingSection innerClassName="section" />

      </main>
      <Footer />
    </div>
  );
}

export default CreditsPage;
